<template>
<div class="col-lg-6">
    <div class="card">
        <div class="card-header pb-0">
            <h3>Shape</h3>
        </div>
        <div class="card-body avatar-showcase">
            <div class="avatars">
                <div class="avatar"><img class="img-100 b-r-8" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar"><img class="img-90 b-r-30" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar"><img class="img-80 b-r-35" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar"><img class="img-70 rounded-circle" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar"><img class="img-60 b-r-25" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar"><img class="img-50 b-r-15" src="@/assets/images/user/1.jpg" alt="#"></div>
            </div>
        </div>
    </div>
</div>
<div class="col-lg-6">
    <div class="card">
        <div class="card-header pb-0">
            <h3>Ratio</h3>
        </div>
        <div class="card-body avatar-showcase">
            <div class="avatars">
                <div class="avatar ratio"><img class="b-r-8 img-100" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar ratio"><img class="b-r-8 img-90" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar ratio"><img class="b-r-8 img-80" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar ratio"><img class="b-r-8 img-70" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar ratio"><img class="b-r-8 img-60" src="@/assets/images/user/1.jpg" alt="#"></div>
                <div class="avatar ratio"><img class="b-r-8 img-50" src="@/assets/images/user/1.jpg" alt="#"></div>
            </div>
        </div>
    </div>
</div>
<div class="col-lg-6 text-start">
  <div class="card">
      <div class="card-header pb-0">
          <h3>Groups</h3>
      </div>
      <div class="card-body avatar-showcase">
          <div class="customers d-inline-block avatar-group">
              <ul>
                  <li class="d-inline-block"><img class="img-70 rounded-circle" src="../../../assets/images/user/3.jpg" alt=""></li>
                  <li class="d-inline-block"><img class="img-70 rounded-circle" src="../../../assets/images/user/5.jpg" alt=""></li>
                  <li class="d-inline-block"><img class="img-70 rounded-circle" src="../../../assets/images/user/1.jpg" alt=""></li>
              </ul>
          </div>
          <div class="customers d-inline-block avatar-group">
              <ul>
                  <li class="d-inline-block"><img class="img-50 rounded-circle" src="../../../assets/images/user/3.jpg" alt=""></li>
                  <li class="d-inline-block"><img class="img-50 rounded-circle" src="../../../assets/images/user/5.jpg" alt=""></li>
                  <li class="d-inline-block"><img class="img-50 rounded-circle" src="../../../assets/images/user/1.jpg" alt=""></li>
              </ul>
          </div>
          <div class="customers d-inline-block avatar-group">
              <ul>
                  <li class="d-inline-block"><img class="img-40 rounded-circle" src="../../../assets/images/user/3.jpg" alt=""></li>
                  <li class="d-inline-block"><img class="img-40 rounded-circle" src="../../../assets/images/user/5.jpg" alt=""></li>
                  <li class="d-inline-block"><img class="img-40 rounded-circle" src="../../../assets/images/user/1.jpg" alt=""></li>
              </ul>
          </div>
      </div>
  </div>
</div>
</template>
